import React from "react";
import {
  Card,
  CardContent,
  Grid,
  Button,
  TextField,
  Box,
  Typography,
} from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import AssessmentIcon from "@material-ui/icons/Assessment";
import { useDispatch } from "react-redux";
//import reportsAction from "./redux/actions/reports";
import reportsAction from "../../../redux/actions/reports"

export default function ReportCard({ report }) {
  
  const [reportDownloading, setReportDownloading] = React.useState(false);
  const dispatch = useDispatch();
  

  function obtenerMesYAnio(texto) {
    const mesActual = new Date().getMonth();
    const anioActual = new Date().getFullYear();
    const emDateOb = { mes: mesActual, anio: anioActual };

    if (!texto || typeof texto !== "string") {
      return emDateOb;
    }

    const meses = {
      enero: 0,
      febrero: 1,
      marzo: 2,
      abril: 3,
      mayo: 4,
      junio: 5,
      julio: 6,
      agosto: 7,
      septiembre: 8,
      octubre: 9,
      noviembre: 10,
      diciembre: 11
    };

    const partes = texto.trim().toLowerCase().split(/\s+/);

    if (partes.length !== 2) {
      return emDateOb;
    }

    const mes = meses[partes[0]];
    const anio = parseInt(partes[1], 10);

    if (mes === undefined || isNaN(anio)) {
      return emDateOb;
    }

    return { mes, anio };
  }

  const downloadReport = async (data) => {
    const { mes, anio } = obtenerMesYAnio(data.dateRange)

    const dateInit = new Date(anio, mes, 1);
    const dateEnd = new Date(anio, mes + 1, 1);

    const formData = {
      localID: data.localID._id,
      datetimeInit: dateInit,
      datetimeFinish: dateEnd,
      month: mes,
      year: anio,
      reportDate: new Date(data.datetimeCreated)
    }

    setReportDownloading(true)

    const response = await dispatch(reportsAction.createReport(formData));
    setReportDownloading(false);
    if (response) {
      const byteArray = new Uint8Array(response.buffer.data);
      const blob = new Blob([byteArray], { type: "application/pdf" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", "file.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  }

  return (
    <Box boxShadow={3}>
      <Card>
        <CardContent>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid item>
              <Typography component="h2" variant="h6">
                Reporte disponible
              </Typography>
            </Grid>
            <Grid item>
              <AssessmentIcon style={{ color: "#00C851" }} />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <hr color="#00C851" style={{ height: 2 }}></hr>
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                value={report.dateRange}
                variant="outlined"
                label="Período"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                value={report.localID.name}
                variant="outlined"
                label="Local"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                color="primary"
                fullWidth
                variant="outlined"
                //onClick={() => window.open(report.url)}
                onClick={() => downloadReport(report)}
                startIcon={<GetAppIcon />}
                style={!reportDownloading ? { color: "#00C851", borderColor: "#00C851" } : { color: "#40644e", borderColor: "#40644e" }}
                disabled={reportDownloading}
              >
                Descargar
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}
